import React from 'react';
import cx from 'clsx';
import Skeleton from 'react-loading-skeleton';

import { IconSystemBadge } from '@/assets/icon/avatar';
import { SystemAccountAvatar } from '@/components';
import { useSwitch } from '@/hooks';
import { alignSystemAccountId } from '@/utils';

import { HiSession } from '../../types';
import HiOperateMenu, { HiOperateMenuType } from '../HiOperateMenu';
import style from './index.module.css';

type HeaderSystemAccountInfoProps = {
  account?: SystemAccount;
  hiSession?: HiSession;
  hideOperationMenu?: boolean;
};

export const HeaderSystemAccountInfo = ({
  account,
  hiSession,
  hideOperationMenu,
}: HeaderSystemAccountInfoProps) => {
  const sessionId = hiSession?.id;

  const { on: showAll, turnOn: setShowAll } = useSwitch(false);

  return (
    <div className={style.headerInfo}>
      <div className={style.userInfo}>
        <div className={style.userInfoMain}>
          <SystemAccountAvatar
            className={style.avatar}
            logoVisible={false}
            size={50}
            data={account}
          />
          <div className={style.userInfoContent}>
            <div className={style.uid}>
              {account ? (
                <>
                  <span className={style.accountName}>{account.name}</span>
                  <IconSystemBadge className={style.badge} />
                </>
              ) : (
                <Skeleton width={264} height={24}></Skeleton>
              )}
            </div>
            <span className={cx(style.intro, showAll && style.showAll)} onClick={setShowAll}>
              {account ? account.desc : <Skeleton width={264} height={20}></Skeleton>}
            </span>
          </div>
        </div>
      </div>
      {hideOperationMenu || !account ? null : (
        <div className={style.operateMenuWrapper}>
          <HiOperateMenu
            config={{
              otherSideHiId: alignSystemAccountId(account?.id),
              otherSideName: account?.name,
              sessionId: sessionId!,
            }}
            menuTypeList={
              hiSession
                ? [
                    hiSession?.is_pinned ? HiOperateMenuType.UNPIN : HiOperateMenuType.PIN,
                    HiOperateMenuType.ARCHIVE,
                  ]
                : []
            }
          />
        </div>
      )}
    </div>
  );
};

export default HeaderSystemAccountInfo;
